export const COMPANY_DETAILS_FORM = 'company-details';
export const CREATE_PASSWORD_FORM = 'create-password';
export const CREATE_USERNAME_AND_PASSWORD_FORM = 'create-username-and-password';
export const FORGOT_PASSWORD_FORM = 'forgot-password';
export const LOGIN_FORM = 'login';
export const SIGNUP_FORM = 'sign-up';

// ONBOARDING
export const ONBOARDING_FORM = 'onboarding';
export const ONBOARDING_PROGRAM_COMPANY_SIZE =
	'onboarding-program-company-size';

// PROGRAM
export const TRAVEL_PROGRAM_FORM = 'travel-program';
export const CREATE_TRAVEL_PROGRAM_FORM = 'create-travel-program';

export const CREATE_PROGRAM_FORM = 'create-program';
export const EDIT_PROGRAM_FORM = 'edit-program';

// GROUP
export const CREATE_GROUP_FORM = 'create-group';
export const EDIT_GROUP_FORM = 'edit-group';

// PEOPLE
export const CREATE_SINGLE_PEOPLE_FORM = 'create-single-people';
export const CREATE_BULK_PEOPLE_FORM = 'create-bulk-people';
export const EDIT_PEOPLE_FORM = 'edit-people';
